<template>
    <b-modal id="modalInfoRotina" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirRotinas" centered>
        <template #modal-header>
            <div class="col-10">
                <h4>Informações da Rotina!</h4>
            </div>
        </template>

        <div class="col-12 ">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Data</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rotina, index) in rotinas" :key="rotina.nr_sequencial">
                        <td>{{ index }}</td>
                        <td>{{ rotina.dt_record }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center; ">
                    <div class="row center" style="justify-content: center; ">
                        <b-button class="mr-2" variant="danger" size="lg" @click="$emit('closeModal')">
                            Fechar
                        </b-button>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            exibirRotinas: true,
        }
    },

    computed: {
        rotinas() {
            return this.$store.getters['painel/getInfoRotina']
        }
    },

}
</script>
<style src="./style.css" ></style>